<template>
  <div></div>
</template>

<script>
export default {
  name: "Prints"
}
</script>

<style scoped>

</style>
